<!-- =========================================================================================
    File Name: CessRulesAddNew.vue
    Description: Add new Cess Rules
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">
        
        <h4> {{ $t("CESSCreateDesciption") }} </h4> <br/>

        <form @submit.prevent="submitForm">

            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <span>
                        {{ $t("StartingDate") }}
                    </span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                     <datepicker placeholder="Starting Date" v-model="StartingDate"></datepicker>
                    <span class="text-danger text-sm" v-show="errors.has('StartingDate')">{{ errors.first('StartingDate') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <span> 
                        {{ $t("ProductName") }}
                    </span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <v-select v-model="ProductId" name="ProductId" :value="ProductId" :options="ProductIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('ProductId')">{{ errors.first('ProductId') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <span>
                        {{ $t("Percentage") }}
                    </span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <vs-input class="w-full" v-model="CessPercentage" v-validate="'required'" name="CessPercentage" />
                    <span class="text-danger text-sm" v-show="errors.has('CessPercentage')">{{ errors.first('CessPercentage') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <span>
                        {{ $t("PerQty") }}
                    </span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <vs-input class="w-full" v-model="ProductQty" v-validate="'required'" name="ProductQty" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductQty')">{{ errors.first('ProductQty') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <span>
                        {{ $t("FixedValue") }}
                    </span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <vs-input class="w-full" v-model="FixedValue" v-validate="'required'" name="FixedValue" />
                    <span class="text-danger text-sm" v-show="errors.has('FixedValue')">{{ errors.first('FixedValue') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <span>
                        {{ $t("HighestCess") }}
                    </span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <v-select v-model="HighestFlag" name="HighestFlag" :value="HighestFlag" :options="HighestFlagOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('HighestFlag')">{{ errors.first('HighestFlag') }}</span>
                </div>
            </div>
            
            <div class="vx-row">
                <div class="vx-col w-full text-right mb-3">
                    <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                    <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';

const dict = {
  custom: {
    ProductId: { required : 'Product Id should not be empty', },
    CessPercentage: { required : 'Cess Percentage should not be empty', },
    ProductQty: { required : 'Product Qty should not be empty', },
    FixedValue: { required : 'Fixed Value should not be empty', },
    HighestFlag: { required : 'Highest Flag should not be empty', },
    StartingDate: { required : 'Starting Date should not be empty', },
  }
};

Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
        Datepicker
    },    
    props: {
        addRecordPrompt: {
            type: Boolean,
            required: true,
        },
    },    
    data() {
        return {
            // activePrompt: false,

            ProductId : '',
            CessPercentage : '',
            ProductQty : '',
            FixedValue : '',
            HighestFlag : '',
            StartingDate : '',

            ProductIdOptions : [],
            DateFormat: "d-MMM-yyyy",
            HighestFlagOptions: this.selectListYesNo(),

        }
    },
    computed: {
        dataArrayLength() {
            return this.$store.getters['cessRules/dataArrayLength'];
        },
        validateForm() {
            return !this.errors.any() && this.PriceGroupName != '' && this.PriceGroupDescription != '';
        },   
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideAddRecordPrompt');
        },
        addRecordDetails() {
            // add todo in store and clear all fields in dialog

            var recordObj={
                "ProductId" :  this.ProductId, 
                "CessPercentage" :  this.CessPercentage, 
                "ProductQty" :  this.ProductQty, 
                "FixedValue" :  this.FixedValue, 
                "HighestFlag" :  this.HighestFlag, 
                "StartingDate" :  this.StartingDate, 
            };

            var server_url=companyConfig.apiURL;
            var record={};
            record.token=this.$session.get('token');
            record.add_url=server_url+'lib/api/product/cess/create';
            record.form=recordObj;
            record.list_url=server_url+'lib/api/product/cess/lists';
            record.list_where={
                "cess_rules_id >=" : 1
            };
            console.log('record='+JSON.stringify(record));
            record.loading=this.$vs.loading;
            record.notify=this.$vs.notify;
            record.http=this.$http;            
            this.$store.dispatch('cessRules/addRecordDetails', record);

            this.closePrompt();
        },
        clearFields() {
            // clear all fileds in todo
            this.GstSlabValue =  '';

            this.$parent.addRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.addRecordDetails();
            })
        }
    },
    beforeMount() {    
        if (!this.$session.exists()) {
        console.log('your session is expired');
        this.$router.push('/');      
        }else{
        
        // var server_url=companyConfig.apiURL;
        
        // Product Dropdown WHERE Product HSN Code not null

        var selectbox1_source = 'ProductId'
        var selectbox1_destination = 'ProductIdOptions'
        var selectbox1_url = 'lib/api/data/get_product_variant_options'
        var selectbox1_conditions_array = {
            'AllProducts': 0,
            'where':{
                "product_details_hsn_code !=": ""
            }            
        }
        this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url);
        }
    },
}
</script>
<style>
.con-vs-popup .vs-popup {
    width: 650px;
}
</style>